// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2U5Wg","head":"ProcedureTableInfo_head__2sHaK"};